import { INPROGRESS_REQUESTS } from 'vrlcm-gui-constants';
export var isRequestInprogress = function (requestState) {
    return INPROGRESS_REQUESTS.includes(requestState);
};
